<div id="chart" class="w-full">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [dataLabels]="chartOptions.dataLabels"
    [stroke]="chartOptions.stroke"
    [title]="chartOptions.title"
    [legend]="chartOptions.legend"
    [fill]="chartOptions.fill"
    [grid]="chartOptions.grid"
    [plotOptions]="chartOptions.plotOptions"
  ></apx-chart>
</div>
